module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/moneyCard-2fae1e8396e532a651a6434b5cc0fe37.png";